import { defineStore } from 'pinia'
import api from '@/services/axios'

export const useSeoStore = defineStore('seo', {
  state: () => ({
    metaTitle: '',
    metaDescription: '',
    metaKeywords: '',
    websiteDescription: '',
    ogImageUrl: '',
    ogImageWidth: 0,
    ogImageHeight: 0,
    faviconUrl: '',
    loaded: false,
    loading: false
  }),

  getters: {
    title: (state) =>
      state.metaTitle || 'DITAP - Smart Tap Solution untuk Berbagai Identitas Digital',

    description: (state) =>
      state.metaDescription ||
      state.websiteDescription ||
      'Bagikan identitas digital kamu dengan satu tap.',

    keywords: (state) =>
      state.metaKeywords ||
      'nfc, qr code, digital identity, ditap',

    image: (state) => state.ogImageUrl || '',

    imageWidth: (state) => state.ogImageWidth || 0,

    imageHeight: (state) => state.ogImageHeight || 0,

    favicon: (state) => state.faviconUrl || '/favicon.ico'
  },

  actions: {
    async load() {
      if (this.loaded || this.loading) return
      this.loading = true

      try {
        const { data } = await api.get('/public/seo')
        const payload = data?.data || {}

        this.$patch({
          metaTitle: payload.meta_title || '',
          metaDescription: payload.meta_description || '',
          metaKeywords: payload.meta_keywords || '',
          websiteDescription: payload.website_description || '',
          ogImageUrl: payload.og_image_url || '',
          ogImageWidth: Number(payload.og_image_width) || 0,
          ogImageHeight: Number(payload.og_image_height) || 0,
          faviconUrl: payload.favicon_url || '',
          loaded: true
        })
      } catch (error) {
        console.warn('Gagal memuat SEO:', error)
        this.loaded = true
      } finally {
        this.loading = false
      }
    }
  }
})